import { trigger, transition, query, style, group, animate, state } from "@angular/animations";

export let slider = trigger('routeAnimations', [ 
    transition(':increment', slideTo('right') ),
    transition(':decrement', slideTo('left') ),
  ]);

function slideTo(direction) {
  if (localStorage.getItem('Language') == 'Arabic')
      direction = direction == 'right'? 'left':'right';
  const optional = { optional: true };
  return [
    query(':enter, :leave', [   
      style({
        position: 'absolute',
        top: 0, 
        [direction]: 0,
        width: '100%'
      })
    ], optional), 
    query(':enter', [
      style({ [direction]: '-100%'})
    ]),
    group([
      query(':leave', [
        animate('600ms ease', style({ [direction]: '100%'}))
      ], optional),
      query(':enter', [
        animate('600ms ease', style({ [direction]: '0%'}))
      ])
    ]),
  ];  
}